import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFileInvoice, FaSpinner, FaSearch, FaEye } from 'react-icons/fa';
import api from '../../services/api';
import './QuotesList.css';

function QuotesList() {
  const [quotes, setQuotes] = useState([]);
  const [filteredQuotes, setFilteredQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchQuotes();
  }, []);

  useEffect(() => {
    filterQuotes();
  }, [searchTerm, quotes]);

  const fetchQuotes = async () => {
    try {
      const response = await api.get('/api/admin/quotes');
      setQuotes(response.data);
      setFilteredQuotes(response.data);
    } catch (error) {
      console.error('Error fetching quotes:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterQuotes = () => {
    if (!searchTerm.trim()) {
      setFilteredQuotes(quotes);
      return;
    }

    const filtered = quotes.filter((quote) => {
      const search = searchTerm.toLowerCase();
      return (
        quote.fullName?.toLowerCase().includes(search) ||
        quote.emailAddress?.toLowerCase().includes(search) ||
        quote.phoneNumber?.includes(search) ||
        quote.serviceType?.toLowerCase().includes(search) ||
        quote.vehicleType?.toLowerCase().includes(search) ||
        quote.companyName?.toLowerCase().includes(search)
      );
    });

    setFilteredQuotes(filtered);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="quotes-loading">
        <FaSpinner className="spinner" />
        <p>Loading quotes...</p>
      </div>
    );
  }

  return (
    <div className="quotes-list-page">
      <div className="quotes-header">
        <div className="quotes-title">
          <FaFileInvoice />
          <h2>Quote Requests</h2>
          <span className="quotes-count">({quotes.length})</span>
        </div>

        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, email, service, vehicle..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {filteredQuotes.length === 0 ? (
        <div className="no-quotes">
          <FaFileInvoice />
          <p>{searchTerm ? 'No quotes found matching your search' : 'No quote requests yet'}</p>
        </div>
      ) : (
        <div className="quotes-table-container">
          <table className="quotes-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Customer</th>
                <th>Contact</th>
                <th>Service</th>
                <th>Vehicle</th>
                <th>Route</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredQuotes.map((quote) => (
                <tr key={quote._id}>
                  <td className="date-cell">{formatDate(quote.createdAt)}</td>
                  <td>
                    <div className="customer-info">
                      <strong>{quote.fullName}</strong>
                      {quote.companyName && <span className="company">{quote.companyName}</span>}
                    </div>
                  </td>
                  <td>
                    <div className="contact-info">
                      <div>{quote.emailAddress}</div>
                      <div className="phone">{quote.phoneNumber}</div>
                    </div>
                  </td>
                  <td>
                    <span className="badge service-badge">{quote.serviceType}</span>
                  </td>
                  <td>
                    <span className="badge vehicle-badge">{quote.vehicleType}</span>
                  </td>
                  <td>
                    <div className="route-info">
                      <div className="route-point">📍 {quote.collectionPostcode}</div>
                      <div className="route-arrow">→</div>
                      <div className="route-point">📍 {quote.deliveryPostcode}</div>
                    </div>
                  </td>
                  <td>
                    <Link to={`/admin/dashboard/quotes/${quote._id}`} className="view-btn">
                      <FaEye /> View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default QuotesList;

